import { render, staticRenderFns } from "./saleAddonTrash.vue?vue&type=template&id=3e0b6448&scoped=true"
import script from "./saleAddonTrash.vue?vue&type=script&lang=js"
export * from "./saleAddonTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b6448",
  null
  
)

export default component.exports